export enum MeterDetailParent {
  Dashboard = 'dashboard',
  Meters = 'meters',
  LocationDetail = 'locationDetail',
}
